import {
  createContext,
  useState,
  useContext,
  useCallback,
  useEffect,
} from "react";
import Notification from "../components/common/Notification";

export const NOTIFICATION_TYPE = { SUCCESS: "success", ERROR: "error" };

// Create the context
const NotificationContext = createContext();

// Create a provider component
export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: NOTIFICATION_TYPE.SUCCESS,
    autoDismiss: true,
  });

  const showNotification = useCallback(
    (message, type = NOTIFICATION_TYPE.SUCCESS, autoDismiss = true) => {
      setNotification({ show: true, message, type, autoDismiss });
    },
    []
  );

  const showErrorNotification = useCallback((message, autoDismiss = false) => {
    setNotification({
      show: true,
      message,
      type: NOTIFICATION_TYPE.ERROR,
      autoDismiss,
    });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification((prev) => ({ ...prev, show: false }));
  }, []);

  useEffect(() => {
    if (notification.show && notification.autoDismiss) {
      const timer = setTimeout(() => {
        hideNotification();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [notification.show, hideNotification]);

  return (
    <NotificationContext.Provider
      value={{ showNotification, showErrorNotification }}
    >
      {children}
      {notification.show && (
        <Notification
          message={notification.message}
          type={notification.type}
          onDismiss={hideNotification}
        />
      )}
    </NotificationContext.Provider>
  );
};

// Create a custom hook to use the notification context easily
export const useNotification = () => {
  return useContext(NotificationContext);
};
